export const MT_COLLECT_COOKIE = 'xdesign-widgets_collect_cookie';
export const MT_COOKIE_ACCEPT = 'xdesign-accept-cookie';

// 广告 1(旧)
export const AD_CODE1 = 'AW-16450872059';
// 广告 2(新: 2025-04-03 新增)
export const AD_CODE2 = 'AW-16953984632';
